// Планы по поездке
export function stepTravelPlans (proxy)
{
    let controller = {
        checked: false,
        input: false,
    }

    const data = proxy.data
    const step = 'step'+data.step;
    // let resultChecked = [];

    // Получаем объект с LocalStorage
    const dataLocalStorage = data.getStepLocalStorage(proxy.locStorStepId, data.step);
    if (dataLocalStorage) data.setDataFormAddLocalStorage(data.dataForm[step], dataLocalStorage);

    const inputs = proxy.fvcContainerId.querySelectorAll('.ftp_wrapper input[type=checkbox]');
    const wrapperCheckbox = proxy.fvcContainerId.querySelector('.ftp_wrapper_checkbox')
    let cities = proxy.data.dataForm[step].citiesRouter;

    /*inputs.forEach(input => {
        if (cities.indexOf(input.value) !== -1) input.checked = true;

        input.addEventListener('click', function (e) {
            const target = e.target;

            if (target.checked) {
                cities.push(target.value)
                if (wrapperCheckbox.classList.contains('_error')) {
                    wrapperCheckbox.classList.remove('_error');
                    wrapperCheckbox.querySelector('.form_additional_text').remove()
                }
            } else {
                cities.splice(cities.indexOf(target.value),1);
            }

            data.dataForm[step].citiesRouter = cities;
            proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm[step], proxy.data.step);
        })

        if (input.checked) {
            resultChecked.push(true)
            controller.checked = true;
            if (wrapperCheckbox.classList.contains('_error')) {
                wrapperCheckbox.classList.remove('_error');
                wrapperCheckbox.querySelector('.form_additional_text').remove()
            }
        } else {
            resultChecked.push(false)
        }
    })*/

    // Обрабатываем checkbox
    inputs.forEach(input => {
        const label = input.closest('label');

        input.addEventListener('click', function (e) {
            const target = e.target;

            if (target.checked) {
                cities[proxy.fn.getInputId(proxy, target.id)] = target.value
                if (wrapperCheckbox.classList.contains('_error')) {
                    wrapperCheckbox.classList.remove('_error');
                    wrapperCheckbox.querySelector('.form_additional_text').remove()
                }
                if (!label.classList.contains('active')) {
                    label.classList.add('active');
                }
            } else {
                if (label.classList.contains('active')) {
                    label.classList.remove('active');
                }
               delete cities[proxy.fn.getInputId(proxy, target.id)]
            }

            proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm[step], proxy.data.step);
        })

        if (dataLocalStorage.citiesRouter) {
            Object.entries(dataLocalStorage.citiesRouter).forEach((entry) => {
                const [key, value] = entry;
                if (proxy.fn.getInputStepId(proxy, key) === input.id) {

                    if (!label.classList.contains('active')) {
                        label.classList.add('active');
                    }

                    input.checked = true
                    controller.checked = true;
                    if (wrapperCheckbox.classList.contains('_error')) {
                        wrapperCheckbox.classList.remove('_error');
                        wrapperCheckbox.querySelector('.form_additional_text').remove()
                    }
                }
            });
        }


        /*if (input.checked) {
            controller.checked = true;
            if (wrapperCheckbox.classList.contains('_error')) {
                wrapperCheckbox.classList.remove('_error');
                wrapperCheckbox.querySelector('.form_additional_text').remove()
            }
        }*/
    })

    // Проверяем input на _error
    data.errorInputController(proxy, controller);

    // Для мобилы меняем type с date на text
    if (false) { // proxy.debug.notDelLocalStorageAjax
        const inputDate = proxy.fvcContainerId.querySelector('input[type=date]');
        console.log('LocalStorage => ',data.dataForm[step].date)

        if (proxy.fn.getMobileDevise()) {
            inputDate.type = 'text'
            inputDate.dataset.mask = "MM.DD.YYYY"
            inputDate.dataset.format = "**.**.****"

        }

        if (!data.dataForm[step].date) {
            setInputClickLocalStorage(proxy, data.dataForm[step], inputDate)
        }


        function setInputClickLocalStorage (proxy, dataForm, inputDate)
        {
            function doFormat(value, pattern, mask) {
                // удаляем все нечисловые значения из значения
                const strippedValue = value.replace(/[^0-9]/g, "");

                // преобразуем строку-значение в массив символов
                const chars = strippedValue.split('');


                let count = 0;
                let formatted = '';

                // форматируем строку
                for (let i = 0; i < pattern.length; i++) {
                    const char = pattern[i];
                    if (chars[count]) {
                        if (/\*/.test(char)) {
                            formatted += chars[count];
                            count++;
                        } else {
                            formatted += char;
                        }
                    } else if (mask) {
                        const splittedMask = mask.split('');

                        if (splittedMask[i]) {
                            formatted += splittedMask[i];
                        }
                    }
                }

                return formatted;
            }

            function format(elem) {
                const val = doFormat(elem.value, elem.getAttribute('data-format'));
                elem.value = doFormat(elem.value, elem.getAttribute('data-format'), elem.getAttribute('data-mask'));

                if (elem.createTextRange) {
                    let range = elem.createTextRange();
                    range.move('character', val.length);
                    range.select();
                } else if (elem.selectionStart) {
                    elem.focus();
                    elem.setSelectionRange(val.length, val.length);
                }
            }

            inputDate.addEventListener('keyup', function () {
                format(inputDate);
            });

            inputDate.addEventListener('keydown', function () {
                format(inputDate);
            });

            format(inputDate)


            inputDate.addEventListener('input', function (e) {
                console.log(e.target.value.trim())
                dataForm[inputDate.dataset.name] = e.target.value.trim()
                proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataForm, proxy.data.step);
            })
        }
    } else {

    }

    // Перезаписываем LocalStorage при вводе данных в input
    data.setInputClickLocalStorage(proxy, data.dataForm[step]);

    // Заполняем в input данными с dataForm и обновляем dataForm
    data.setTextInputDataForm(proxy.fvcContainerId, data.dataForm[step]);

    // const result = resultChecked.findIndex((item) => item === true);

    proxy.bNext.onclick = function (e) {
        if (Object.keys(dataLocalStorage.citiesRouter).length === 0) {
            const messageHtml = proxy.data.messageHtml;
            wrapperCheckbox.classList.add('_error')
            wrapperCheckbox.insertAdjacentHTML("beforeend", messageHtml('ERROR_REQUIRED_FIELD'));
        }
    }

    if (controller.input && controller.checked) {
        data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, data.dataForm[step], data.step);
        proxy.bNext.classList.add('in');
    }
}